const BASE_PATH = "/auth";
export default class AuthApis {
  constructor(apisClient) {
    this.apis = apisClient;
  }

  async login(email, password) {
    return this.apis.post({
      path: `${BASE_PATH}/login`,
      body: {
        email,
        password
      }
    });
  }

  async logout() {
    return this.apis.get({
      path: `${BASE_PATH}/logout`
    });
  }

  async resetUsernamePassword(oldPassword, newPassword) {
    return this.apis.post({
      path: `${BASE_PATH}/reset-username-password`,
      body: {
        oldPassword,
        newPassword
      }
    });
  }

  async resetEmailPassword(email) {
    return this.apis.post({
      path: `${BASE_PATH}/reset-email-password`,
      body: {
        email
      }
    });
  }

  async validateInviteLink(link) {
    return this.apis.post({
      path: `${BASE_PATH}/validate-invite`,
      body: {
        link
      }
    });
  }

  async updatePassword(oobCode, newPassword, newPasswordConfirmation) {
    return this.apis.post({
      path: `${BASE_PATH}/update-password`,
      body: {
        oobCode,
        newPassword,
        newPasswordConfirmation
      }
    });
  }

  async getCurrentUser() {
    return this.apis.get({
      path: `${BASE_PATH}/me`
    });
  }

  async getUserPreferences() {
    return this.apis.get({
      path: `${BASE_PATH}/preferences`
    });
  }

}